@if (config$ | async; as config) {
  <app-advanced-reports [config]="config" [rowData]="rowData$ | async"></app-advanced-reports>
}
